import { connect } from 'react-redux';
import AddButton from './AddButton';
import { fetchProductsBySection, setAddedProducts } from '../../../../../store/form/actions';
import {
  getAddedProducts,
  getInputDataToSend,
  getTreeStructureSettings,
} from '../../../../../store/form/selectors';

const mapStateToProps = (state) => ({
  inputData: getInputDataToSend(state),
  treeStructureSettings: getTreeStructureSettings(state),
  addedProducts: getAddedProducts(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchProductsBySection: (
    fetchSettings,
  ) => {
    dispatch(fetchProductsBySection(
      fetchSettings,
    ));
  },
  setAddedProducts: (uniqueItem) => {
    dispatch(setAddedProducts(uniqueItem));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AddButton);
